import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-verificar-emision-cheque-gerencia',
  templateUrl: './verificar-emision-cheque-gerencia.component.html',
  styleUrls: ['./verificar-emision-cheque-gerencia.component.scss'],
})
export class VerificarEmisionChequeGerenciaComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      // titularEmisorCarta: [values ? values.titularEmisorCarta : '', [Validators.required]],
      // firma: [values ? values.firma : '', [Validators.required]],
      sellos: [values ? values.sellos : false, [Validators.required]],
      firma: [values ? values.firma : false, [Validators.required]],
      telefonos: [values ? values.telefonos : false, [Validators.required]],
      cuenta: [values ? values.cuenta : false, [Validators.required]],
      contenidoCorreo: [
        values ? values.contenidoCorreo : false,
        [Validators.required],
      ],
      monto: [values ? values.monto : false, [Validators.required]],
    });
  }
  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
